import { useContext } from 'react';

import { AuthContext } from '../context/context';
import type { IAuthContext } from '../context/context';

const useAuth = (): IAuthContext => {
  const context = useContext<IAuthContext>(AuthContext);

  return context;
};

export default useAuth;
